(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mrbr-brands"] && !Shopify.designMode) return;
  try {
    
const root = document.querySelector('[data-mrbr-brands]');
if (root) {
  const bar = root.querySelector('[data-brands-bar]');
  const input = root.querySelector('[data-brands-search]');
  const suggest = root.querySelector('[data-brands-suggest]');
  const groups = [...root.querySelectorAll('[data-brand-group]')];
  const links = [...root.querySelectorAll('[data-brand-name]')];
  const empty = root.querySelector('[data-brands-empty]');
  const header = document.querySelector('.site-header');

  const pin = () => {
    const height = header ? header.offsetHeight : 0;
    bar.style.top = height + 'px';
  };
  pin();
  window.addEventListener('resize', pin);

  root.querySelectorAll('.mrbr-brands-az a').forEach((link) => {
    link.addEventListener('click', (event) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      const offset = (header ? header.offsetHeight : 0) + bar.offsetHeight + 8;
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  });

  const applyQuery = () => {
    const query = input.value.trim().toLowerCase();
    suggest.replaceChildren();
    if (!query) {
      links.forEach((link) => { link.hidden = false; });
      groups.forEach((group) => { group.hidden = false; });
      suggest.hidden = true;
      empty.hidden = true;
      return;
    }
    let shown = 0;
    groups.forEach((group) => {
      let groupShown = 0;
      group.querySelectorAll('[data-brand-name]').forEach((link) => {
        const name = link.dataset.brandName.toLowerCase();
        const match = name.startsWith(query);
        link.hidden = !match;
        if (match) {
          groupShown += 1;
          const item = document.createElement('a');
          item.href = link.href;
          item.textContent = link.dataset.brandName;
          suggest.appendChild(item);
        }
      });
      group.hidden = groupShown === 0;
      shown += groupShown;
    });
    suggest.hidden = shown === 0;
    empty.hidden = shown !== 0;
  };

  input.addEventListener('input', applyQuery);
}

  } catch(e) { console.error(e); }
})();
})();
